import { Action, createReducer, on } from '@ngrx/store';

import * as LoaderActions from './loader.actions';
import * as LoaderFeatureState from './loader.state';

const loaderReducer = createReducer(
  LoaderFeatureState.initialLoaderState,

  on(LoaderActions.showLoaderUntil, (state, { actionType }) => ({
    ...state,
    actionType,
    showLoader: true,
  })),

  on(LoaderActions.resetState, () => ({
    actionType: '',
    showLoader: false,
  }))
);

export function reducer(
  state: LoaderFeatureState.LoaderState | undefined,
  action: Action
) {
  return loaderReducer(state, action);
}
